import React from 'react'
import { Link } from 'react-router-dom'
import { Experiment, Variation } from '@deal/experiment-js'
import { Button } from '@deal/components'
import { generateCreateUrlFromCategory } from '#src/services/path'
import useBreakpoint from '#src/hooks/useBreakpoint'
import PageContent from '#src/components/PageContent'
import styles from './styles.css'

interface CategoryHeaderProps {
  categorySlug: string
}

const CategoryHeader: React.SFC<CategoryHeaderProps> = ({ categorySlug }) => {
  const buttonSize = useBreakpoint('md') ? 'large' : 'small'

  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <PageContent>
          <Experiment id="category-header" default="v1">
            <Variation id="v1">
              <>
                <div className={styles.itemCount}>739 clubs available</div>
                <div className={styles.title}>
                  Take a quick golf quiz and have an expert find your new clubs for free
                </div>
                <div className={styles.actions}>
                  <Link to={generateCreateUrlFromCategory(categorySlug)}>
                    <Button size={buttonSize}>Take golf quiz</Button>
                  </Link>
                </div>
              </>
            </Variation>
            <Variation id="v2">
              <>
                <div className={styles.itemCount}>739 clubs available</div>
                <div className={styles.title}>What can we help you with today?</div>
                <div className={styles.actions}>
                  <Link
                    to={generateCreateUrlFromCategory(categorySlug, {
                      golfShoppingGoal: 'FIRST_SET'
                    })}
                    className={styles.cardButton}
                  >
                    <span className={styles.copy}>I'm shopping for my first set of clubs</span>
                    <span className={styles.selectBox}>Select</span>
                  </Link>
                  <Link
                    to={generateCreateUrlFromCategory(categorySlug, {
                      golfShoppingGoal: 'UPGRADING'
                    })}
                    className={styles.cardButton}
                  >
                    <span className={styles.copy}>I'm upgrading my current golf clubs</span>
                    <span className={styles.selectBox}>Select</span>
                  </Link>
                  <Link
                    to={generateCreateUrlFromCategory(categorySlug, {
                      golfShoppingGoal: 'LOOKING_FOR_SPECIFIC'
                    })}
                    className={styles.cardButton}
                  >
                    <span className={styles.copy}>I'm looking for specific golf clubs</span>
                    <span className={styles.selectBox}>Select</span>
                  </Link>
                </div>
              </>
            </Variation>
          </Experiment>
        </PageContent>
      </div>
    </div>
  )
}

export default CategoryHeader
